/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 10:21:13
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-13 18:32:24
 */
/* eslint-disable */
import config from '@/config/config'
import { mapState, mapMutations, mapActions } from 'vuex'

const login = {
  data () {
    return {
      code: '', // 用户登录凭证（有效期五分钟）
      refreshJwt: 0
    }
  },
  computed: {
    ...mapState({
      mxUserInfo: state => state.userInfo,
      mxCompanyId: state => state.switchInfo.companyId,
      mxSettlementId: state => state.switchInfo.settlementId,
    })
  },
  methods: {
    ...mapMutations({
      setUserIsLogin  : 'user/setUserIsLogin'
    }),
    ...mapActions(['refreshToken']),
    // ------------|初始化|------------
    loginInit () {
      this.checkJwt() // 检查JWT
      return Promise.resolve(true)
    },
    // 刷新赋值
    loginRefresh () {
      const { refreshJwt } = this
      if (!refreshJwt) {
        this.refreshJwt = 1
        this.refreshToken()  // VUEX重新赋值JWT
        this.refreshJwt = 0
      }
    },
    // 异步:检查JWT(JSON Web Token)
    async checkJwt () {
      // 获取 storage jwt 赋值的时间
      let jwtTime = this.$storage.get('jwtTime') * 1
      // 获取当前时间
      let time = Date.parse(new Date())
      // JWT使用时间:当前时间-赋值时间
      let passTime = time - jwtTime
      let passSeconds = parseInt(passTime / (1000 * 60))
      // 如果不存在:用户首次登录/用户重新开启
      if (!jwtTime) {
        this.setUserIsLogin(false) // 设为未登陆
      } else {
        // 过期:使用时长 > 有效期
        if (passTime > config.tokenTime) {
          this.setUserIsLogin(false) // 设为未登陆
        }
        // 在有效期内并且时间未过半
        else if (config.tokenTime >= passTime &&
          passTime > parseInt(config.tokenTime / 2)) {
          this.setUserIsLogin(true) // 设为已登陆
          this.loginRefresh()
        }
        // 未过期
        else {
          this.setUserIsLogin(true) // 设为已登陆
          if (Object.keys(this.mxUserInfo).length === 0) {
            this.loginRefresh()
          }
        }
      }
    },
  },
}

export default login
